import * as SettingTypes from "../types/settings.types";
import * as UiTypes from "../types/ui.types";
import axiosInstance from "../../api";
import { alertActions } from "./alert.actions";

export const loadSettings = () => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: SettingTypes.LOADING_SETTINGS });

  axiosInstance
    .get("/config/")
    .then((res) => {
      dispatch({
        type: SettingTypes.LOAD_SETTINGS,
        payload: res.data,
      });
      dispatch({ type: UiTypes.CLEAR_ERRORS });
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Network Issue",
        });
      }
    });
};

export const loadGenearlSettings = () => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: SettingTypes.LOADING_SETTINGS });

  axiosInstance
    .get("/config/general")
    .then((res) => {
      dispatch({
        type: SettingTypes.LOAD_SETTINGS,
        payload: res.data,
      });
      dispatch({ type: UiTypes.CLEAR_ERRORS });
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Network Issue",
        });
      }
    });
};

export const getSetting = () => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: SettingTypes.FETCH_SETTINGS_REQUEST });

  axiosInstance
    .get("user/userdetails")
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch({
        type: SettingTypes.FETCH_SETTINGS_REQUEST_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch(alertActions.error(err.response.data.detail.toString()));
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: err.response.data.detail.toString(),
        });
      }
    });
};

export const updateSetting = (userData: any, id: number) => (dispatch: any) => {
  //dispatch({ type: UiTypes.LOADING_UI })
  dispatch({ type: SettingTypes.SETTINGS_SAVE_REQUEST });

  axiosInstance
    .put(
      "profile/" + id,
      userData /*, {
    headers:{
      'Content-Type': 'multipart/form-data'
    }
  }*/
    )
    .then((res) => {
      //dispatch({type:UiTypes.CLEAR_ERRORS});

      dispatch(alertActions.success("Setting Updated Successfully"));
      dispatch({ type: SettingTypes.SETTINGS_SAVE_SUCCESS });
      //dispatch(loadPeople(1))
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch(alertActions.error(err.response.data.detail.toString()));
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: err.response.data.detail.toString(),
        });
      }
    });
};

export const addSettings = (userData: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: SettingTypes.SETTINGS_SAVE_REQUEST });

  axiosInstance
    .post("config/", userData)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch({ type: SettingTypes.SETTINGS_SAVE_SUCCESS });
      dispatch(alertActions.success("Setting added Successfully"));
      dispatch(loadSettings());
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch(alertActions.error(err.response.data.detail.toString()));
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: err.response.data.detail.toString(),
        });
      }
    });
};
